<template>
  <div>
    <Form ref="formValidate" :model="formValidate" :label-width="120">
      <Row type="flex" justify="center">
        <Col span="18">
          <FormItem label="日期" prop="recordDate">
            <DatePicker class="widK" type="date" disabled v-model="formValidate.recordDate" placeholder="选择日期" format="yyyy-MM-dd"></DatePicker>
          </FormItem>
          <FormItem label="姓名" prop="name">
            <Input class="widK" disabled v-model.trim="formValidate.name" placeholder="姓名"></Input>
          </FormItem>
          <FormItem label="身份证号码" prop="idCard">
            <Input class="widK" disabled v-model.trim="formValidate.idCard" placeholder="身份证号码"></Input>
          </FormItem>
          <FormItem label="参与大类" prop="category">
            <CheckboxGroup v-model="formValidate.categoryList" disabled>
              <Checkbox v-for="item in categoryList" :key="item.value" :label="item.label">{{ item.label }}</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="具体事项" prop="detail">
            <Input class="widK" type="textarea" disabled v-model.trim="formValidate.detail" placeholder="具体事项"></Input>
          </FormItem>
          <FormItem label="积分" prop="branch">
            <Input class="widK" disabled v-model.trim="formValidate.branch" placeholder="积分"></Input>
          </FormItem>
          <FormItem label="审核状态">
            <Input class="widK" disabled :value="formValidate.status == 10 ? '已审核' : '待审核'"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Button type="default" @click="back">返回</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  name: "integralPeopleItemDetail",
  data() {
    return {
      categoryList: [
        { label: "乡风文明", value: "乡风文明" },
        { label: "文体健康", value: "文体健康" },
        { label: "矛盾调解", value: "矛盾调解" },
        { label: "建言献策", value: "建言献策" },
        { label: "基层治理", value: "基层治理" },
        { label: "人居环境", value: "人居环境" },
      ],
      formValidate: { categoryList: [] },
    };
  },
  created() { this.init(); },
  methods: {
    init() {
      if (this.$byStoreHas(this.$route.name)) {
        this.id = this.$byStoreGet(this.$route.name).id || "";
        this.fromTab = this.$byStoreGet(this.$route.name).fromTab || "pending";
      } else { this.$router.push({ name: "404" }); }
      if (this.id) this.getParams(this.id);
    },
    getParams(id) {
      this.$http.get("/api/tIntegralPeopleItem/get", { params: { id } }).then(r => {
        let data = r.data.data;
        if (data.recordDate) data.recordDate = new Date(data.recordDate);
        data.categoryList = data.category ? data.category.split("、") : [];
        this.formValidate = data;
      });
    },
    back() {
      this.$store.commit("app/closePage", {
        vm: this,
        fromName: this.$route.name,
        toName: "integralPeopleItemAudit",
      });
    },
  },
};
</script>
<style scoped>#content { width: 100%; } .disabled { pointer-events: none; }</style>
